import React, { forwardRef } from 'react';
import { Input, Stack, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import SearchResultModal from "./SearchResultModal";
import http, { AUTH_ROUTES } from "../../../service/api";
import { useGetState } from "../../../context/useGetState";
import useSmallScreen from "../../../components/useSmallScreen";

// function RoundBackgroundInput({ children, sm, deferredSearchInput, ...props }) {
  const RoundBackgroundInput = forwardRef(({ children, sm, deferredSearchInput, ...props }, ref) => {
  
  const inputBg = useColorModeValue(
    { background: "#FAFAFA" },
    { background: "#fff", color: "#000" }
  );
  const [loading, setLoading] = useState(false);
  const [smallScreen] = useSmallScreen();
  const { state } = useGetState();
  const account_type = state?.userInfo?.account_type;

  const [searchResult, setSearchResult] = useState([]);
  const [refresh, setRefresh] = useState({});
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(true);
  const [isDivOpen, setIsDivOpen] = useState(props?.searchText?.length > 0 ? true : true);

  //console.log('RsearchModalOpen: ', isSearchModalOpen)

  useEffect(() => {
    if (!deferredSearchInput) {
      setSearchResult([]);
      return;
    }
    setLoading(true);
    http
      .get(AUTH_ROUTES.SEARCH_USER(deferredSearchInput, account_type))
      .then(({ data }) => {
        setLoading(false);
        setSearchResult(data?.data);
        //console.log('searchResult: ', data?.data);
      })
      .catch((err) => {
        setLoading(false);
        setSearchResult([]);
      });
  }, [deferredSearchInput, refresh]);

  const style = `
  .st{
     -webkit-transition: width .1s ease-in-out;
    -moz-transition: width .1s ease-in-out;
    -o-transition: width .1s ease-in-out;
    transition: width .1s ease-in-out;
  }
  `;

  const closeSearchModal = () => {
    setIsDivOpen(false)
  }
  return (
    <>
      <style>{style}</style>
      <Stack
        className="st"
        direction={"row"}
        alignItems="center"
        {...inputBg}
        p={sm ? "2px" : `5px ${!props.toggle ? "5px" : "10px"} 5px 5px`}
        {...props}
        w={
          smallScreen && props.toggle
            ? "90px"
            : props?.toggle
            ? "300px"
            : "40px"
        }
      >
        {props.toggle && (
          <Input
            {...props}
            size={"sm"}
            {...inputBg}
            value={props.searchText}
            flex="1"
            onChange={(e) => props.setSearchText(e.target.value)}
            onBlur={closeSearchModal}
            cursor={"text !important"}
          />
        )}

        {children}
      </Stack>

      <SearchResultModal
        //style={{display: isSearchModalOpen ? "block" : "none" }}
        setRefresh={setRefresh}
        searchResult={searchResult}
        searchText={props.searchText}
        setSearchText={props.setSearchText}
        loading={loading}
        isSearchModalOpen={isSearchModalOpen}
        isDivOpen={isDivOpen}
        setIsDivOpen={setIsDivOpen}
        //openModal={false}
      />
    </>
  );
})

export default RoundBackgroundInput;
